import { render, staticRenderFns } from "./AscTab.vue?vue&type=template&id=80939c5c&"
import script from "./AscTab.vue?vue&type=script&lang=js&"
export * from "./AscTab.vue?vue&type=script&lang=js&"
import style0 from "./AscTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabs})
